module.exports = __webpack_public_path__ + "media/Resources/Article-ec0e3d02.svg";